import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorTaskCategoryNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface ITaskCategoryModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const ITaskCategoryFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useTaskCategoryHookNae(id: number) : ITaskCategoryModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorTaskCategoryNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.TaskCategory.schema,
        fields: ITaskCategoryFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
